<template>

    <div class="container mt-5">
        <div class="row">
            <div class="col-md-6">
                <div class="card p-4">
                    <div class="card-body">

                        <h2>Выполнить выплату (В разработке)</h2>
                        <!--сделать валидацию формы -->
                        <!--<div class="alert alert-success" v-if=""></div>-->

<!--                        <form>-->
<!--                            <div class="row">-->
<!--                                <div class="col-md-4">-->
<!--                                    <div class="form-group">-->
<!--                                        <label>Id мерчанта</label>-->
<!--                                        <input type="text" class="form-control" :value="merchant.id" readonly disabled>-->
<!--                                    </div>-->
<!--                                </div>-->

<!--                                <div class="col-md-8">-->

<!--                                    <div class="form-group">-->
<!--                                        <label>Секретный ключь</label>-->
<!--                                        <input type="text" class="form-control" :value="merchant.secret_key" readonly disabled>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->

<!--                            <div class="form-group">-->
<!--                                <label>Номер заказа</label>-->
<!--                                <input type="text" v-model="data.reference_id" class="form-control" placeholder="Введите номер заказа">-->
<!--                            </div>-->

<!--                            <div class="form-group">-->
<!--                                <label>Описание платежа</label>-->
<!--                                <input type="text" v-model="data.description" class="form-control" placeholder="Введите описание платежа">-->
<!--                            </div>-->

<!--                            <div class="form-group">-->
<!--                                <label>Ссылка для перенаправления</label>-->
<!--                                <input type="text" v-model="data.request_url" class="form-control" placeholder="Введите урл адрес" >-->
<!--                            </div>-->

<!--                            <div class="form-group">-->
<!--                                <label>Ссылка для колбека</label>-->
<!--                                <input type="text" v-model="data.back_url" class="form-control" value="https://1x.kz" >-->
<!--                            </div>-->

<!--                            <div class="form-group">-->
<!--                                <label>Сумма платежа</label>-->
<!--                                <input type="text" v-model="data.amount" class="form-control" placeholder="Введите сумму платежа">-->
<!--                            </div>-->

<!--                            <div class="form-group">-->
<!--                                <label>ID пользователя</label>-->
<!--                                <input type="text" v-model="data.user_id" class="form-control" placeholder="Введите id пользователя">-->
<!--                            </div>-->

<!--                            <div class="form-group">-->
<!--                                <label>Email</label>-->
<!--                                <input type="email" v-model="data.user_email" class="form-control" placeholder="Введите email плательщика">-->
<!--                            </div>-->

<!--                            <div @click="generateLink" class="d-flex justify-content-center mt-3 mb-3">-->
<!--                                <button class="btn btn btn-primary">Получить ссылку на оплату</button>-->
<!--                            </div>-->
<!--                        </form>-->

                        <div class="alert alert-info p-4 mt-4" role="alert">
                            <span v-text="paymentLink"></span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div class="card p-4">
                    <div class="card-body">

                        <h2>Проверить статус платежа</h2>

                        <form @submit.prevent="">

                            <div class="form-group">
                                <label>Номер заказа</label>
                                <input type="text" class="form-control" placeholder="Введите номер заказа">
                            </div>

                            <div class="d-flex justify-content-center mt-3 mb-3">
                                <button class="btn btn-primary">Проверить</button>
                            </div>

                            <div class="alert alert-success" role="alert">
                                Оплачено!
                            </div>

                            <div class="alert alert-warning" role="alert">
                                Еще не оплачено.
                            </div>
                        </form>


                    </div>
                </div>
            </div>
        </div>
    </div>

</template>


<script>
    import {mapState} from 'vuex';
    import bcryptjs from 'bcryptjs';

    export default {
        name: 'DynamicLinkPayin',
        data() {
            return {
                data: {
                    reference_id: '' + 6543535,
                    request_url: 'https://1x.kz',
                    back_url: 'https://1x.kz',
                    description: 'test',
                    amount: 1,
                    user_id: 1,
                    user_email: 'nomikztop@gmail.com',
                },
                paymentLink: ''
            }
        },
        computed: {
            ...mapState({
                merchant: state => state.merchant
            })
        },
        mounted() {
            //
        },
        methods: {
            generateLink() {
                this.$store.commit('setLoading');

                this.data.secret_key = bcryptjs.hashSync(this.data.reference_id + this.merchant.secret_key, 10);

                this.data.merchant_id = this.merchant.id;
                this.data.is_test = true;
                setTimeout(() => {
                    axios.post('https://core.test/invoice/create', this.data)
                        .then((response) => {
                            this.paymentLink = response.data.data.redirect_url;
                            this.$store.commit('unsetLoading')
                        })
                        .catch(() => {
                            console.log('error');
                            this.$store.commit('unsetLoading')
                        });
                }, 2000);

            }
        }
    }
</script>